export const getAuth0AppEnabled = (state) =>
    state.authentication?.featureFlags?.auth0AppEnabled;

export const getLaunchAsyncStrategyForAuthSocialScripts = (state) =>
    state.authentication?.featureFlags?.launchAsyncStrategyForAuthSocialScripts;

export const getLaunchGoogleOneTapWeb = (state) =>
    state.authentication?.featureFlags?.launchGoogleOneTapWeb;

export const getLaunchPasswordlessLogin = (state) =>
    state.authentication?.featureFlags?.launchPasswordlessLogin;

export const getLaunchLoginWithVerificationCode = (state) =>
    state.authentication?.featureFlags?.launchLoginWithVerificationCode;

export const getShowCaptcha = (state) => state.authentication?.displayCaptcha;

export const getRecaptcha2PublicKey = (state) =>
    state.authentication?.recaptcha2PublicKey;

export const getRecaptcha3PublicKey = (state) =>
    state.authentication?.recaptcha3PublicKey;

export const getDisableRecaptcha3 = (state) =>
    state.authentication?.disableRecaptcha3;

export const getEmail = (state) => state.authentication?.email;

export const getReferralValidationResponse = (state) =>
    state.authentication?.referral_validation_response;
